import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import heroServices from "@/assets/hero-services.jpg";
const Services = () => {
  const servicesSection = useScrollAnimation();
  const services = [{
    name: "Wash, Haircut & Finish",
    price: "€41",
    description: "Complete knipbeurt met wassen en stylen voor een perfect resultaat"
  }, {
    name: "Cut & beard trim deluxe with towels",
    price: "€69",
    description: "Premium behandeling met knipbeurt, baard trim en warme handdoeken",
    popular: true
  }, {
    name: "Beard Trim with towels",
    price: "€36",
    description: "Professionele baard trim inclusief warme handdoeken behandeling"
  }, {
    name: "Cut & beard trim no towels",
    price: "€53",
    description: "Combinatie van knipbeurt en baard trim voor een complete look"
  }, {
    name: "Buzz Cut",
    price: "€29",
    description: "Korte militaire snit, snel en strak geknipt"
  }, {
    name: "Young Gentlemen",
    price: "€33",
    description: "Speciale knipbeurt voor jonge heren tot 17 jaar"
  }];
  return <div className="min-h-screen">
      <SEO
        title="Diensten & Prijzen | Bo Barbers Utrecht"
        description="Bekijk de behandelingen en prijzen van Bo Barbers: knippen, fades, baardverzorging en klassieke shaves. Vakwerk in Utrecht."
        path="/services"
      />
      <Header />
      
      {/* Hero */}
      <section className="relative min-h-[60vh] md:min-h-[60vh] flex items-center overflow-hidden pt-20">
        <div className="absolute inset-0 overflow-hidden">
          <img src={heroServices} alt="Bo Barbers Services" className="w-full h-full object-cover animate-cinematic-zoom" />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        <div className="container mx-auto px-4 sm:px-6 relative z-10 py-24 sm:py-28 md:py-32">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-white/70 uppercase tracking-[0.2em] sm:tracking-[0.3em] mb-4 sm:mb-6 text-xs font-semibold animate-fade-in" style={{
            animationDelay: "0.2s",
            animationFillMode: "forwards"
          }}>
              ONZE SERVICES
            </p>
            <h1 style={{
            animationDelay: "0.4s",
            animationFillMode: "forwards"
          }} className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 sm:mb-8 text-white leading-[0.95] animate-fade-in px-4 xl:text-5xl">
              Sharp cuts. Clean trims.
              <br />
              Honest pricing.
            </h1>
            <div className="w-16 sm:w-24 h-1 bg-white mx-auto mb-6 sm:mb-8 animate-fade-in" style={{
            animationDelay: "0.6s",
            animationFillMode: "forwards"
          }}></div>
            <p className="text-white/80 max-w-xl mx-auto text-sm sm:text-base leading-relaxed animate-fade-in px-4" style={{
            animationDelay: "0.8s",
            animationFillMode: "forwards"
          }}>
              Onze behandelingen zijn gericht op vakmanschap, detail en een verzorgde uitstraling. Van een strakke fade tot een klassieke shave: alles wordt uitgevoerd met aandacht voor jouw stijl.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section ref={servicesSection.ref} className="py-16 sm:py-24 md:py-32 bg-darkSection">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {services.map((service, i) => <Card key={i} className={`group p-6 sm:p-8 md:p-10 bg-white border-white/10 relative transition-all duration-700 hover:shadow-2xl hover:-translate-y-2 ${service.popular ? 'ring-2 ring-white scale-105' : ''} ${servicesSection.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{
            transitionDelay: servicesSection.isVisible ? `${i * 100}ms` : '0ms'
          }}>
                {service.popular && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-darkSection text-white px-4 sm:px-6 py-1 sm:py-1.5 rounded-full text-[10px] sm:text-xs font-bold uppercase tracking-[0.15em] sm:tracking-[0.2em] border border-white/20">
                    Populair
                  </div>}
                
                <div className="mb-4 sm:mb-6">
                  <div className="flex items-baseline justify-between mb-2 sm:mb-3">
                    <div className="text-3xl sm:text-4xl font-bold text-foreground tabular-nums">{service.price}</div>
                    <div className="w-8 sm:w-12 h-px bg-foreground/20 group-hover:bg-foreground transition-colors"></div>
                  </div>
                  <h2 className="font-display text-base sm:text-lg font-bold text-foreground uppercase tracking-[0.05em] leading-tight">
                    {service.name}
                  </h2>
                </div>
                
                <p className="text-foreground/60 text-sm leading-relaxed">
                  {service.description}
                </p>

                <div className="absolute bottom-0 left-0 w-full h-1 bg-foreground scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
              </Card>)}
          </div>
        </div>
      </section>


      <Footer />
    </div>;
};
export default Services;